import { render, staticRenderFns } from "./LahanBarcodeHistory.vue?vue&type=template&id=568a6300"
import script from "./LahanBarcodeHistory.vue?vue&type=script&lang=js"
export * from "./LahanBarcodeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports